<div class="flex">
  @if (showLabel) {
    <label [for]="labelFor" class="block text-sm font-medium text-gray-800 mb-2">
      {{ labelText }}
    </label>
  }
  @if (showInfo) {
    <i class="fa fa-info-circle ml-3" tabindex="0"
       [eskPopover]="infoPopoverKeyVal"
       eskPopoverPlacement="right">
    </i>
  }
  @if (showDollarInfo) {
    <i class="fa fa-dollar-sign ml-3" tabindex="0"
       [eskPopover]="dollarPopoverKeyVal"
       eskPopoverPlacement="right">
    </i>
  }
</div>
